<template>
  <el-dialog
    v-if="openlookDialog"
    :visible.sync="openlookDialog"
    :title="isLook ? '预览视频' : '编辑视频'"
    :append-to-body="true"
    :before-close="handleClose"
    width="80%"
    custom-class="look-video-dialog"
  >
    <div class="video-box">
      <div class="videoPlayer">
        <xg-player ref="player" :url="videoUrl" :timeStamps="timeStamps" @triggerEvent="triggerEvent" @timeupdate="timeupdate"></xg-player>
        <el-button class="add-timestamp-button" type="primary" @click="addTimestamp" v-if="!isLook">创建时间戳</el-button>
      </div>
      <div class="video-time-table" v-if="timeStamps.length > 0 && !isLook">
        <div class="time-stamp-list">
            <div class="video-time-item" v-for="(item, index) in timeStamps" :key="index">
                <div class="item-content">
                    <div class="item-inputs">
                        <div class="input-group">
                          <label>时间</label>
                          <el-input size="mini" v-model="item.t" placeholder="时间"></el-input>
                        </div>
                        <div class="input-group">
                          <label>时间戳标题</label>
                          <el-input size="mini" maxlength="10" v-model="item.tag" placeholder="时间戳标题"></el-input>
                        </div>
                    </div>
                    <div class="item-cover">
                        <!-- <label>时间戳封面</label> -->
                        <uploadCover
                          :imageUrl="item.img"
                          @uploadFileUrl="uploadImg"
                          @clearImage="clearImage"
                          @validate="validateImage"
                          :objKey="`img_${index}`"
                          :isHideInput="true" 
                        ></uploadCover>
                    </div>
                </div>
                <div class="item-delete" @click="deleteTimestamp(index)">
                    <span>删除</span>
                </div>
            </div>
            <div class="save-button">
                <el-button type="primary" @click="saveTimestamp(1)">保存</el-button>
                <el-button type="primary" @click="saveTimestamp(2)" v-if="!this.isVideo">提交</el-button>
            </div>
        </div>
      </div>
      <!-- <div class="video-time-preview" v-if="timeStamps.length > 0 && isLook">
        <div class="preview-title">视频时间节点</div>
        <div class="timestamp-preview-list">
          <div 
            class="timestamp-preview-item" 
            v-for="(item, index) in sortedTimeStamps" 
            :key="index"
            @click="jumpToTime(item.t)"
          >
            <div class="preview-cover">
              <img v-if="item.img" :src="setImages(item.img)" alt="时间节点封面" />
              <div v-else class="no-cover">
                <i class="el-icon-video-camera"></i>
              </div>
            </div>
            <div class="preview-info">
              <div class="preview-title">{{ item.tag || '时间节点' }}</div>
              <div class="preview-time">{{ formatTime(item.t) }}</div>
            </div>
            <div class="preview-jump">
              <i class="el-icon-caret-right"></i>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </el-dialog>
</template>

<script>
import config from "../../../utils/serverUrlConfig";
import local from "@/utils/localStroage.js";
import XgPlayer from './XgPlayer.vue';
import API from "@/api";
import uploadCover from './uploadCover.vue';
export default {
  props: {
    isLook: {
      type: Boolean,
      default: true
    },
    isVideo: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
    data(){
        return{
            openlookDialog:false,
            videoUrl:"",
            timeStamps: [],
            currentTime: 0,
            duration: 0,
            videoId: '',
        }
    },
    components: {
      XgPlayer,
      uploadCover
    },
    computed: {
      sortedTimeStamps() {
        return this.timeStamps.slice().sort((a, b) => a.t - b.t);
      }
    },
    methods:{
      addTimestamp() {
        if (this.timeStamps.length >= 5) {
          this.$message.error('最多只能创建5个时间戳');
          return;
        }
        // this.timeStamps.push({ t: this.currentTime, tag: '', img: '' });
        this.$refs.player.captureAndUploadCover().then((res) => {
          console.log(res, 'res');
          this.timeStamps.push({ t: this.formatTime(res.screenshot.currentTime), tag: '', img: res.uploadResult});
          this.timeStamps = JSON.parse(JSON.stringify(this.timeStamps));
        })
      },
      deleteTimestamp(index) {
        this.timeStamps.splice(index, 1);
      },
      loadVideo(data, obj) {
        if(obj) {
          this.videoId = obj.id || '';
          this.media_type = obj.media_type || '';
        }
        if(obj && obj.points && obj.points.length > 0){
          try {
            this.timeStamps = JSON.parse(obj.points) || [];
            this.timeStamps.forEach(item => {
              item.t = this.formatTime(item.t);
            });
          } catch (error) {
            this.timeStamps = obj.points;
          }
        }else{
          this.timeStamps = [];
        }
        this.videoUrl  = `${config.baseServerUrl}/api/m3u8/${data}?token=${local.get('userInfo').token}`
      },
      triggerEvent(value){
        console.log("是否播放：",value);
      },
      handleClose() {
        if (this.$refs.player && this.$refs.player.teardown) {
          this.$refs.player.teardown();
        } else if (this.$refs.player && this.$refs.player.destroyPlayer) {
          this.$refs.player.destroyPlayer();
        }
        this.openlookDialog = false;
      },
      timeupdate(value) {
        // console.log("时间戳：",value);
        this.currentTime = Math.floor(value.currentTime);
        this.duration = Math.floor(value.duration);
        // console.log("当前时间：",this.currentTime);
        // console.log("总时长：",this.duration);
      },
      saveTimestamp(type) {
        // console.log("保存时间戳：",this.timeStamps);
        let timeStamps = JSON.parse(JSON.stringify(this.timeStamps));
        timeStamps.forEach(item => {
          item.t = item.t.toString().split(':').reduce((acc, curr, index) => acc + curr * (index === 0 ? 3600 : index === 1 ? 60 : 1), 0);
        });
        // console.log("保存时间戳：",timeStamps);
        if(this.isVideo || this.isEdit){
          API.videoUpdateAuto({
            id: this.videoId,
            points: timeStamps,
            media_type: this.media_type
          }).then((res) => {
            console.log(res, "res");
            if(res.code === 0){
              this.$message.success("保存成功");
              this.$emit("handlerClose");
              this.$emit("handlerSave");
              this.handleClose();
            }else{
              this.$message.error(res.msg || "保存失败");
            }
          })
        } else {
          let obj = {
            id: this.videoId,
            points: timeStamps,
            media_type: this.media_type
          }
          if(type == 2){
            obj.status = 1;
          }
          API.taskPointUpdate(obj).then((res) => {
            if(res.code === 0){
              this.$message.success("保存成功");
              this.$emit("handlerClose");
              this.$emit("handlerSave");
              this.handleClose();
            }else{
              this.$message.error(res.msg || "保存失败");
            }
          })
        }
      },
      uploadImg(key, url) {
        this.timeStamps.forEach((item, index) => {
          if(index == key.split('_')[1]){
            item.img = url;
          }
        });
        this.timeStamps = JSON.parse(JSON.stringify(this.timeStamps));
      },
      clearImage(key) {
        this.timeStamps.forEach((item, index) => {
          if(index == key.split('_')[1]){
            item.img = '';
          }
        });
        this.timeStamps = JSON.parse(JSON.stringify(this.timeStamps));
      },
      validateImage(key, url) { 
        this.timeStamps.forEach((item, index) => {
          if(index == key.split('_')[1]){
            item.img = url;
          }
        });
        this.timeStamps = JSON.parse(JSON.stringify(this.timeStamps));
      },
      jumpToTime(time) {
        if (this.$refs.player && this.$refs.player.dPlayer) {
          this.$refs.player.dPlayer.seek(time);
        }
      },
      formatTime(seconds) {
        if (!seconds || isNaN(seconds)) return '00:00:00';
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
      },
      setImages(val) {
        // 判断是否拥有域名 如果有 去掉域名 字符串第一位是'/'
        if (val.indexOf("http") === 0) {
          val = "/" + val.split("/").slice(3).join("/");
        } else if (val.indexOf("/") !== 0) {
          val = "/" + val;
        }
        // 根据去掉域名后的数据进行匹配
        let data = JSON.parse(JSON.parse(localStorage.getItem("imageUrl")));
        let strValue = "";
        for (const key in data) {
          if (key.indexOf("/") !== 0 && key !== "*") {
            //如果匹配键名前面不带'/'
            if (val.indexOf("/" + key + "/") === 0) {
              //
              strValue = data[key];
            }
          } else if (key.indexOf("/") === 0 && key !== "*") {
            //带'/'
            if (val.indexOf(key + "/") === 0) {
              //有匹配的
              strValue = data[key];
            }
          }
        }
        if (strValue) {
          return strValue + val;
        } else {
          return data["*"] + val;
        }
      }
    }
}
</script>

<style lang="scss" scoped>
.video-box {
  display: flex;
}
.videoPlayer {
  flex: 1;
  height: 600px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}
.video-time-table {
  width: 400px;
  display: flex;
  flex-direction: column;
}
.time-stamp-list {
    flex-grow: 1;
    overflow-y: auto;
    margin-bottom: 10px;
    max-height: 550px;
    padding-right: 10px;
}
.video-time-item {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-items: stretch;
  overflow: hidden;
}
.item-content {
    padding: 10px;
    display: flex;
    flex-grow: 1;
    align-items: center;
}
.item-inputs {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 15px;
    gap: 10px;
}
.input-group {
  display: flex;
  align-items: center;
}
.input-group label {
    font-size: 12px;
    color: #606266;
    margin-bottom: 5px;
    min-width: 70px;
}
.item-cover {
    display: flex;
}
.item-cover label {
    font-size: 12px;
    color: #606266;
    margin-bottom: 5px;
    text-align: center;
    min-width: 70px;
}
.cover-placeholder {
  width: 60px;
  height: 60px;
  background: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #8c939d;
}
.item-delete {
    background-color: #fff0f0;
    color: #f56c6c;
    border: none;
    padding: 0 10px;
    cursor: pointer;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 2px;
    border-left: 1px solid #e9ecef;
}
.item-delete:hover {
    background-color: #fde2e4;
}
.add-timestamp-button {
  width: 100px;
  margin-top: 10px;
}

::v-deep .video-js .vjs-time-control{
  display: inline-block !important;
  padding: 0 2px !important;
  text-align: center;
}
.save-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
:deep(.look-video-dialog) {
  height: auto !important;
}
.video-time-preview {
  width: 400px;
  padding: 20px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  max-height: 550px;
  overflow-y: auto;
}
.preview-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 15px;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 2px solid #409eff;
}
.timestamp-preview-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.timestamp-preview-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #f0f9ff;
    border-color: #409eff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
}
.preview-cover {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  margin-right: 12px;
  flex-shrink: 0;
  border: 2px solid #e4e7ed;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.no-cover {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #909399;
  font-size: 20px;

  i {
    font-size: 24px;
  }
}
.preview-info {
  flex: 1;
  min-width: 0;
  
  .preview-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .preview-time {
    font-size: 12px;
    color: #409eff;
    font-weight: 500;
    background: rgba(64, 158, 255, 0.1);
    padding: 2px 8px;
    border-radius: 12px;
    display: inline-block;
  }
}
.preview-jump {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #409eff;
  font-size: 16px;
  transition: transform 0.2s ease;
}

.timestamp-preview-item:hover .preview-jump {
  transform: translateX(3px);
}
</style>
